import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import VivahLogo from './VivahLogo';
import './Navbar.css';

const NAVS = {
  consult: {
    label: 'Vivah Nepal Matrimonial Agency',
    host: 'Owner: Laxmikant Timilsina (9857074103)',
    cls: 'tc',
    links: [
      { to: '/consultation', end: true, label: 'Verified Matches' },
      { to: '/consultation/about', label: 'Agency Info' },
      { to: '/consultation/payment', label: 'QR Registration' },
      { to: '/consultation/profile', label: 'My Profile' },
      { to: '/contact', label: 'Contact Office' }
    ]
  },
  decor: {
    label: 'Sabitri Decor & Tent House',
    host: 'Owner: Krishna Khanal (9867155395)',
    cls: 'td',
    links: [
      { to: '/decor', end: true, label: 'About Decor' },
      { to: '/decor/catalog', label: 'Palpali Mandaps' },
      { to: '/decor/quote', label: 'Get Quote' },
      { to: '/decor/booking', label: 'Booking' },
      { to: '/contact', label: 'Office' }
    ]
  },
  catering: {
    label: 'Sabitri Catering Services',
    host: 'Owner: Krishna Khanal (9867155395)',
    cls: 'ts',
    links: [
      { to: '/catering', end: true, label: 'About Catering' },
      { to: '/catering/team', label: 'Leadership & Technical Team' },
      { to: '/catering/menu', label: 'Feast Menus' },
      { to: '/catering/quote', label: 'Get Quote' },
      { to: '/catering/booking', label: 'Booking' },
      { to: '/contact', label: 'Office' }
    ]
  },
};

export default function Navbar({ module }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const nav = module ? NAVS[module] : null;

  return (
    <header className="navbar-container">
      {/* Partner Dual Banner */}
      <div className="top-banner">
        <div className="top-banner-content">
          <div className="banner-left">
            <span>📍 Shared Office: <strong>Yogikuti Chowk, Butwal-10, Lumbini, Nepal</strong></span>
          </div>
          <div className="banner-right">
            <span>
              💍 <strong>Vivah Nepal</strong> (Laxmikant T.): <a href="tel:9857074103">9857074103</a> | 
              🎪 <strong>Sabitri Catering</strong> (Krishna K.): <a href="tel:9867155395">9867155395</a>
            </span>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className="navbar">
        <div className="nb" onClick={() => navigate('/')}>
          <VivahLogo size="medium" />
        </div>

        <div className="nl">
          {!module && (
            <>
              <NavLink className={({ isActive }) => 'nl' + (isActive ? ' a' : '')} to="/consultation">
                Vivah Nepal Matrimony
              </NavLink>
              <NavLink className={({ isActive }) => 'nl' + (isActive ? ' a' : '')} to="/decor">
                Sabitri Decor & Mandap
              </NavLink>
              <NavLink className={({ isActive }) => 'nl' + (isActive ? ' a' : '')} to="/catering">
                Sabitri Catering Feast
              </NavLink>
              <NavLink className={({ isActive }) => 'nl' + (isActive ? ' a' : '')} to="/catering/team">
                Team & Leadership
              </NavLink>
              <NavLink className={({ isActive }) => 'nl' + (isActive ? ' a' : '')} to="/contact">
                Contact Office
              </NavLink>
            </>
          )}

          {nav && (
            <>
              <span className={`nt ${nav.cls}`}>{nav.label}</span>
              {nav.links.map((l) => (
                <NavLink
                  key={l.to}
                  end={l.end}
                  to={l.to}
                  className={({ isActive }) => `nl ${nav.cls}${isActive ? ' a' : ''}`}
                >
                  {l.label}
                </NavLink>
              ))}

              {module === 'consult' && (
                user ? (
                  <button className="nl" onClick={async () => { await logout(); navigate('/'); }}>
                    Logout
                  </button>
                ) : (
                  <NavLink className={({ isActive }) => 'nl' + (isActive ? ' a' : '')} to="/consultation/login">
                    Login / Register
                  </NavLink>
                )
              )}

              <button className="nb2" onClick={() => navigate('/')}>
                ← Partner Home
              </button>
            </>
          )}
        </div>
      </nav>
    </header>
  );
}
